import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

const PHONE_WIDTH = '(max-width: 767px)';

/** Screens up to phone width get the compact layout. */
@Injectable({ providedIn: 'root' })
export class ConductViewportService {
  private readonly phone = inject(BreakpointObserver).observe(PHONE_WIDTH);

  readonly compact = toSignal(this.phone.pipe(map((state) => state.matches)), {
    initialValue: false,
  });
}
